import { v4 as uuid } from "uuid";
import {
  dogBandana,
  dogCollar,
  dogFoodApple,
  dogFoodPumpkin,
  dogToy,
  treatDispenser,
  birdFeeder,
  birdFood,
  catClimber,
  catCollar,
  catPetsyTreat,
  catToy,
  catWhiskas,
  fishFilter,
  fishFood,
  fishGlowToy,
  fishMedicine,
  fishToy,
  fishTreat,
  rabbitFood,
  rabbitToy,
  rabbitTreat
} from '../../assets/images/product'

/**
 * Product Database can be added here.
 * You can add products of your wish with different attributes
 * */

export const products = [
  {
    _id: uuid(),
    name: "Riley's Apple Munchies",
    category: "Dogs",
    type: 'Treat',
    description: 'Healthy snacks for dogs',
    price: 500,
    discount: 10,
    badge: '',
    image: dogFoodApple,
    rating: 1.5,
    addedToWishList: false,
    addedToCart: false,
    cartCount: 0
  },
  {
    _id: uuid(),
    name: "Riley's Pumpkin Munchies",
    category: "Dogs",
    type: 'Treat',
    description: 'Healthy snacks for dogs',
    price: 300,
    discount: '',
    badge: '',
    image: dogFoodPumpkin,
    rating: 4.5,
    addedToWishList: false,
    addedToCart: false,
    cartCount: 0
  },
  {
    _id: uuid(),
    name: "Foggy Squeaky Toy",
    category: "Dogs",
    type: 'Toy',
    description: 'Fun play time Toy',
    price: 700,
    discount: 20,
    badge:'SALE',
    image: dogToy,
    rating: 3.5,
    addedToWishList: false,
    addedToCart: false,
    cartCount: 0
  },
  {
    _id: uuid(),
    name: "Riley's Treat Dispenser",
    category: "Dogs",
    type: 'Toy',
    description: 'Fun play time Toy',
    price: 1000,
    discount: '',
    badge:'New',
    image: treatDispenser,
    rating: 4.8,
    addedToWishList: false,
    addedToCart: false,
    cartCount: 0
  },
  {
    _id: uuid(),
    name: "Riley's Orange Bandana",
    category: "Dogs",
    type: 'Accessory',
    description: 'Pure cotton soft print',
    price: 300,
    discount: '',
    badge:'New',
    image: dogBandana,
    rating: 4.5,
    addedToWishList: false,
    addedToCart: false,
    cartCount: 0
  },
  {
    _id: uuid(),
    name: "Riley's Dog Collar",
    category: "Dogs",
    type: 'Accessory',
    description: 'Classy, light-weight, skin-friendly',
    price: 770,
    discount: 15,
    badge:'SALE',
    image: dogCollar,
    rating: 4.5,
    addedToWishList: false,
    addedToCart: false,
    cartCount: 0
  },
  {
    _id: uuid(),
    name: "Bird Feeder",
    category: "Birds",
    type: 'Accessory',
    description: 'Modern, durable, light-weight',
    price: 800,
    discount: 0,
    badge:'New',
    image: birdFeeder,
    rating: 4.0,
    addedToWishList: false,
    addedToCart: false,
    cartCount: 0
  },
  {
    _id: uuid(),
    name: "Organic Bird Food",
    category: "Birds",
    type: 'Food',
    description: 'Healthy, natural diet food',
    price: 200,
    discount: 5,
    badge:'SALE',
    image: birdFood,
    rating: 4.3,
    addedToWishList: false,
    addedToCart: false,
    cartCount: 0
  },
  {
    _id: uuid(),
    name: "Cat Wood Climber",
    category: "Cats",
    type: 'Toy',
    description: 'Fun playtime pal',
    price: 1500,
    discount: 0,
    badge:'New',
    image: catClimber,
    rating: 4.3,
    addedToWishList: false,
    addedToCart: false,
    cartCount: 0
  },
  {
    _id: uuid(),
    name: "Cat Collar",
    category: "Cats",
    type: 'Accessory',
    description: 'Skin friendly, washable',
    price: 300,
    discount: 10,
    badge:'SALE',
    image: catCollar,
    rating: 4.0,
    addedToWishList: false,
    addedToCart: false,
    cartCount: 0
  },
  {
    _id: uuid(),
    name: "Petsy Cat Treats",
    category: "Cats",
    type: 'Treat',
    description: 'Natural, no added preservatives',
    price: 300,
    discount: 30,
    badge:'SALE',
    image: catPetsyTreat,
    rating: 4.7,
    addedToWishList: false,
    addedToCart: false,
    cartCount: 0
  },
  {
    _id: uuid(),
    name: "Mouse Chew Toy",
    category: "Cats",
    type: 'Toy',
    description: 'Pack of 3',
    price: 300,
    discount: 0,
    badge:'New',
    image: catToy,
    rating: 4.8,
    addedToWishList: false,
    addedToCart: false,
    cartCount: 0
  },
  {
    _id: uuid(),
    name: "Whiskas Baby Food",
    category: "Cats",
    type: 'Food',
    description: 'Safe for your baby cats',
    price: 300,
    discount: 10,
    badge:'New',
    image: catWhiskas,
    rating: 4.0,
    addedToWishList: false,
    addedToCart: false,
    cartCount: 0
  },
  {
    _id: uuid(),
    name: "Fish Filter",
    category: "Fishes",
    type: 'Accessory',
    description: 'Maintains tank super clean',
    price: 900,
    discount: 0,
    badge:'',
    image: fishFilter,
    rating: 4.0,
    addedToWishList: false,
    addedToCart: false,
    cartCount: 0
  },
  {
    _id: uuid(),
    name: "Fish Food Pellets",
    category: "Fishes",
    type: 'Food',
    description: 'Dried, healthy',
    price: 400,
    discount: 0,
    badge:'',
    image: fishFood,
    rating: 3.0,
    addedToWishList: false,
    addedToCart: false,
    cartCount: 0
  },
  {
    _id: uuid(),
    name: "Glowy Jellyfish",
    category: "Fishes",
    type: 'Toy',
    description: 'Light up your tank in a jiffy',
    price: 350,
    discount: 0,
    badge:'',
    image: fishGlowToy,
    rating: 4.4,
    addedToWishList: false,
    addedToCart: false,
    cartCount: 0
  },
  {
    _id: uuid(),
    name: "Fish Treat",
    category: "Fishes",
    type: 'Treat',
    description: 'Drools fish treats',
    price: 150,
    discount: 0,
    badge:'',
    image: fishTreat,
    rating: 4.1,
    addedToWishList: false,
    addedToCart: false,
    cartCount: 0
  },
  {
    _id: uuid(),
    name: "Water Enhancer",
    category: "Fishes",
    type: 'Medicine',
    description: 'Enhances tank water',
    price: 250,
    discount: 5,
    badge:'New',
    image: fishMedicine,
    rating: 4.0,
    addedToWishList: false,
    addedToCart: false,
    cartCount: 0
  },
  {
    _id: uuid(),
    name: "Fish Toy",
    category: "Fishes",
    type: 'Toy',
    description: 'fun and loving toy',
    price: 200,
    discount: 10,
    badge:'SALE',
    image: fishToy,
    rating: 3.9,
    addedToWishList: false,
    addedToCart: false,
    cartCount: 0
  },
  {
    _id: uuid(),
    name: "Bunny Food",
    category: "Bunnies",
    type: 'Food',
    description: '100% natural',
    price: 100,
    discount: 0,
    badge:'',
    image: rabbitFood,
    rating: 4.0,
    addedToWishList: false,
    addedToCart: false,
    cartCount: 0
  },
  {
    _id: uuid(),
    name: "Wooden Swing",
    category: "Bunnies",
    type: 'Toy',
    description: 'Fun, easy, light-weight',
    price: 1200,
    discount: 10,
    badge:'',
    image: rabbitToy,
    rating: 3.8,
    addedToWishList: false,
    addedToCart: false,
    cartCount: 0
  },
  {
    _id: uuid(),
    name: "Rabbit treat toy",
    category: "Bunnies",
    type: 'Treat',
    description: 'toys + treat, wins all the time',
    price: 300,
    discount: 0,
    badge:'',
    image: rabbitTreat,
    rating: 4.3,
    addedToWishList: false,
    addedToCart: false,
    cartCount: 0
  }
];
